import agendamento from './agendamento'
import agendamentoRetroativo from './agendamentoRetroativo'
import alteracaoConsultasFinalizadas from './alteracaoConsultasFinalizadas'
import atendimento from './atendimento'
import fechamentoConsulta from './fechamentoConsulta'
import gerenciamentoDiario from './gerenciamentoDiario'
import gerenciamentoMedico from './gerenciamentoMedico'
import jornada from './jornada'
import jornadaBloqueio from './jornadaBloqueio'
import jornadaSituacao from './jornadaSituacao'
import listagemConsultaAgendadaRealizada from './listagemConsultaAgendadaRealizada'
import parametrizacao from './parametrizacao'
import preAtendimento from './preAtendimento'
import recepcao from './recepcao'
import relatorioConsultaFinalizada from './relatorioConsultaFinalizada'
import relatorioConsultaSolicitada from './relatorioConsultaSolicitada'
import relatorioEstatisticoConsulta from './relatorioEstatisticoConsulta'
import relatorioEstatisticoPaciente from './relatorioEstatisticoPaciente'
import relatorioEstatisticoStatus from './relatorioEstatisticoStatus'
import relatorioIdentificacao from './relatorioIdentificacao'
import relatorioJornada from './relatorioJornada'
import relatorioPacienteAtendimento from './relatorioPacienteAtendimento'
import relatorioProcedimento from './relatorioProcedimento'
import relatorioProcedimentoLancadoPeriodo from './relatorioProcedimentoLancadoPeriodo'
import relatorioProducaoAmbulatorial from './relatorioProducaoAmbulatorial'
import relatorioQuantitativoAtendimento from './relatorioQuantitativoAtendimento'
import relatorioQuantitativoCid from './relatorioQuantitativoCid'
import relatorioQuantitativoConsultaSolicitada from './relatorioQuantitativoConsultaSolicitada'
import relatorioQuantitativoProcedimento from './relatorioQuantitativoProcedimento'
import relatorioQuantitativoProducao from './relatorioQuantitativoProducao'
import servico from './servico'
import supervisor from './supervisor'
import historico from './historico'

export default [
    {
        component: () => import('@/components/base/RouterViewWrapper'),
        path: 'ambulatorio',
        children: [
            ...agendamento,
            ...agendamentoRetroativo,
            ...alteracaoConsultasFinalizadas,
            ...atendimento,
            ...fechamentoConsulta,
            ...gerenciamentoDiario,
            ...gerenciamentoMedico,
            ...jornada,
            ...jornadaBloqueio,
            ...jornadaSituacao,
            ...listagemConsultaAgendadaRealizada,
            ...parametrizacao,
            ...preAtendimento,
            ...recepcao,
            ...relatorioConsultaFinalizada,
            ...relatorioConsultaSolicitada,
            ...relatorioEstatisticoConsulta,
            ...relatorioEstatisticoPaciente,
            ...relatorioEstatisticoStatus,
            ...relatorioIdentificacao,
            ...relatorioJornada,
            ...relatorioPacienteAtendimento,
            ...relatorioProcedimento,
            ...relatorioProcedimentoLancadoPeriodo,
            ...relatorioProducaoAmbulatorial,
            ...relatorioQuantitativoAtendimento,
            ...relatorioQuantitativoCid,
            ...relatorioQuantitativoConsultaSolicitada,
            ...relatorioQuantitativoProcedimento,
            ...relatorioQuantitativoProducao,
            ...servico,
            ...supervisor,
            ...historico,
        ],
    }
]